var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.66C23.7 11.06 25.06 9.7 25.66 8H32L26 22C26 25.32 29.14 28 33 28C36.86 28 40 25.32 40 22L34 8H38V4H25.66C24.84 1.66 22.62 0 20 0C17.38 0 15.16 1.66 14.34 4H2V8H6L0 22C0 25.32 3.14 28 7 28C10.86 28 14 25.32 14 22L8 8H14.34C14.94 9.7 16.3 11.06 18 11.66V34H0V38H40V34H22V11.66ZM36.74 22H29.26L33 13.28L36.74 22ZM10.74 22H3.26L7 13.28L10.74 22ZM20 8C18.9 8 18 7.1 18 6C18 4.9 18.9 4 20 4C21.1 4 22 4.9 22 6C22 7.1 21.1 8 20 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.5aeb1e1c3bb3b04824f7e6fbacf6043a.svg";
export { ForwardRef as ReactComponent };